import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faArrowRight, faShieldHalved, faGem, faClock, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Image1 from "../Images/image 1.png";
import Image2 from "../Images/image 2.png";
import Image3 from "../Images/image 3.png";
import "../Styles/Hero.css";

const slides = [
  {
    image: Image1,
    label: "PROFESSIONAL DRYWALL SERVICES",
    title: ["QUALITY.", "PRECISION.", "PERFECTION."],
    subtitle: "We provide top-quality drywall and stucco services for residential and commercial properties.",
  },
  {
    image: Image2,
    label: "EXPERT STUCCO SOLUTIONS",
    title: ["DURABLE.", "BEAUTIFUL.", "LASTING."],
    subtitle: "Premium stucco installation and repair that protects and beautifies your property for decades.",
  },
  {
    image: Image3,
    label: "COMPLETE RENOVATION SERVICES",
    title: ["TRANSFORM.", "RESTORE.", "PERFECT."],
    subtitle: "From popcorn removal to full demolition repair — we handle it all with expert craftsmanship.",
  },
];

function Hero() {
  const [goUp, setGoUp] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [animating, setAnimating] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goToSlide = useCallback((index) => {
    if (animating) return;
    setAnimating(true);
    setCurrentSlide(index);
    setTimeout(() => setAnimating(false), 800);
  }, [animating]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const onPageScroll = () => setGoUp(window.scrollY > 600);
    window.addEventListener("scroll", onPageScroll);
    return () => window.removeEventListener("scroll", onPageScroll);
  }, []);

  const slide = slides[currentSlide];

  return (
    <>
      <section className="hero-section">
        {/* Slides */}
        {slides.map((s, i) => (
          <div
            key={i}
            className={`hero-slide ${i === currentSlide ? "hero-slide-active" : ""}`}
          >
            <img src={s.image} alt="" className="hero-slide-img" />
          </div>
        ))}
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <span className="hero-label" key={`label-${currentSlide}`}>
            {slide.label}
          </span>
          <div className="hero-line"></div>
          <h1 className="hero-title" key={`title-${currentSlide}`}>
            {slide.title.map((line, i) => (
              <span key={i} className={`hero-title-line hero-title-line-${i + 1}`}>
                {i === slide.title.length - 1 ? (
                  <span className="hero-title-accent">{line}</span>
                ) : (
                  line
                )}
                {i < slide.title.length - 1 && <br />}
              </span>
            ))}
          </h1>
          <p className="hero-subtitle" key={`sub-${currentSlide}`}>
            {slide.subtitle}
          </p>
          <div className="hero-buttons">
            <Link to="/services" className="hero-btn-primary">
              Our Services <FontAwesomeIcon icon={faArrowRight} className="hero-btn-icon" />
            </Link>
            <Link to="/contact-us" className="hero-btn-secondary">
              Contact Us
            </Link>
          </div>

          {/* Slide Dots */}
          <div className="hero-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`hero-dot ${i === currentSlide ? "hero-dot-active" : ""}`}
                onClick={() => goToSlide(i)}
                aria-label={`Go to slide ${i + 1}`}
              ></button>
            ))}
          </div>
        </div>

        {/* Trust Bar */}
        <div className="hero-trust-bar">
          <div className="trust-item">
            <div className="trust-icon">
              <FontAwesomeIcon icon={faShieldHalved} />
            </div>
            <div className="trust-text">
              <strong>LICENSED & INSURED</strong>
              <span>Fully licensed and insured for your peace of mind.</span>
            </div>
          </div>
          <div className="trust-item">
            <div className="trust-icon">
              <FontAwesomeIcon icon={faGem} />
            </div>
            <div className="trust-text">
              <strong>PREMIUM QUALITY</strong>
              <span>We use the best materials for lasting results.</span>
            </div>
          </div>
          <div className="trust-item">
            <div className="trust-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="trust-text">
              <strong>ON-TIME COMPLETION</strong>
              <span>We respect your time and always meet deadlines.</span>
            </div>
          </div>
          <div className="trust-item">
            <div className="trust-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="trust-text">
              <strong>EXPERT TEAM</strong>
              <span>Skilled professionals with years of experience.</span>
            </div>
          </div>
        </div>
      </section>

      <div onClick={scrollToTop} className={`scroll-up ${goUp ? "show-scroll" : ""}`}>
        <FontAwesomeIcon icon={faAngleUp} />
      </div>
    </>
  );
}

export default Hero;
